package org.gstechnovos.jexonplastech.sections.products.styles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.silk.style.CssStyle
import org.gstechnovos.jexonplastech.theme.toSitePalette

val ProductsHeaderContainerStyle = CssStyle {
    val palette = colorMode.toSitePalette()
    base {
        Modifier.fillMaxWidth()
            // Consistent with your brand's premium headers
            .backgroundColor(palette.brand.primaryBlue)
    }
}